export * from '../responsavel/list/responsavelList.component';
export * from '../responsavel/create/responsavelCreate.component';
export * from '../responsavel/edit/responsavelEdit.component';
export * from '../responsavel/detail/responsavelDetail.component';
export * from '../responsavel/search/responsavelSearch.component';